"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _reduxPersist = require("redux-persist");

var _storage = _interopRequireDefault(require("redux-persist/lib/storage"));

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _logOnlyInProduction = require("redux-devtools-extension/logOnlyInProduction");

var _index = _interopRequireDefault(require("../reducers/index"));

var _migrations = _interopRequireDefault(require("./migrations"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _default = function _default() {
  var configOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultConfig = {
    key: 'root',
    version: 2,
    storage: _storage.default,
    whitelist: ['vehicle', 'user'],
    migrate: (0, _reduxPersist.createMigrate)(_migrations.default, {
      debug: false
    })
  };

  var config = _objectSpread({}, defaultConfig, configOverrides);

  var persistedReducer = (0, _reduxPersist.persistReducer)(config, _index.default);
  var enhancer = (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk.default //TODO: loggerMiddleWare
  ), (0, _logOnlyInProduction.devToolsEnhancer)());
  var store = (0, _redux.createStore)(persistedReducer, enhancer);
  var persistor = (0, _reduxPersist.persistStore)(store);

  if (module.hot) {
    module.hot.accept(function () {
      var nextRootReducer = require('../reducers');

      store.replaceReducer((0, _reduxPersist.persistReducer)(config, nextRootReducer));
    });
  }

  return {
    store: store,
    persistor: persistor
  };
};

exports.default = _default;